import { createWebHistory, createRouter } from "vue-router";

import auth from "@/auth/authView.vue"
import login from "@/auth/loginPgae.vue"
import BodyView from '../layout/bodyPage.vue'
import indexDefault from '../component/dashboard/default/indexDefault.vue'
import indexEcommerce from '../component/dashboard/e-commerce/indexEcommerce.vue'
import indexGeneral from '../component/widgets/general/indexGeneral.vue'
import indexChart from '../component/widgets/charts/indexChart.vue'
import createProject from '../component/project/createproject/createProject.vue'
import indexList from '../component/project/projectlist/indexList.vue'
import fileManager from '../component/fileManager.vue'
import kanbanView from '../component/kanban/indexKanban.vue'
import bookMark from '../component/bookmark/bookMark.vue'
import contactView from '../component/contact/contactView.vue'
import calendarView from '../component/calenderView.vue'
import todoView from '../component/todo/todoPage.vue'

import indexProduct from '../component/ecommerce/product/indexProduct.vue'
import productPage from '../component/ecommerce/productpage/productPage.vue'
import productList from '../component/ecommerce/list/productList.vue'
import paymentDetails from '../component/ecommerce/payment/details/paymentDetails.vue'
import orderHistory from '../component/ecommerce/order/history/orderHistory.vue'
import invoiceView from '../component/ecommerce/invoice/invoiceView.vue'
import cartView from '../component/ecommerce/cart/cartView.vue'
import wishlistView from '../component/ecommerce/wishlist/wishlistView.vue'
import checkoutView from '../component/ecommerce/checkout/checkoutView.vue'
import pricingView from '../component/ecommerce/pricing/pricingView.vue'
import mailInbox from '../component/email/mailInbox/mailInbox.vue'
import readMail from '../component/email/readMail/readMail.vue'
import composeView from '../component/email/compose/composeView.vue'
import chatApp from '../component/chat/chatApp/chatApp.vue'
import videoChat from '../component/chat/videoChat/videoChat.vue'
import userProfile from '../component/users/profile/userProfile.vue'
import userCards from '../component/users/cards/userCards.vue'
import userEdit from '../component/users/edit/userEdit.vue'


import formValidation from "../component/forms/formValidetion/formValidation"
import base_Input from "../component/forms/baseInput/base_Input"
import checkbox_radio from "../component/forms/Checkbox&Radio/checkbox_radio"
import input_groups from "../component/forms/InputGroup/input_groups"
import megaOptions from "../component/forms/megaOptions/megaOptions"


import select2 from "../component/formWidgets/select2/select2Page.vue"
import switch_From from "../component/formWidgets/switch/switch_From"
import touchspin_Form from "../component/formWidgets/touchspin/touchspin_Form"
import typeahead_Form from "../component/formWidgets/typeahead/typeahead_Form"
import clipboard_Form from "../component/formWidgets/clipboard/clipboard_Form"
import datepicker from "../component/formWidgets/datepicker/datePicker.vue"
import timepicker from "../component/formWidgets/timepicker/timePicker.vue"
import datetimepicker from "../component/formWidgets/datetimepicker/dateTimePicker.vue"
import daterangepicker from "../component/formWidgets/datetimerange/dateTimeRange.vue"

import defaultforms from '../component/formLayout/default/defaultFotrm.vue'
import form_wizard2 from "../component/formLayout/formWizrd2/form_wizard.vue"
import form_wizard1 from '../component/formLayout/formWizard1/form_wizard2.vue'
import form_wizard3 from "../component/formLayout/formWizard3/form_wizard1.vue"


import BootstrapBasic from "../component/tables/bootstrapTable/basicTables/basic_tables.vue";
import BootstrapTablelayout from "../component/tables/bootstrapTable/tablecomponent/tableComp.vue";

import DatatableBasic from "../component/tables/dataTable/BasicInit/basic_Init.vue";


import HelperclassesPage from "../component/uikits/helper-classes/helper_classes.vue";
import AvatarsPage from "../component/uikits/avatars/avatars_Uikits.vue";
import GridPage from "../component/uikits/grid/grid_Uikits.vue";
import TagpillsPage from "../component/uikits/tag-pills/tag_pills.vue";
import TypographyPage from "../component/uikits/Typography/typograPhy.vue";
import ProgressbarPage from "../component/uikits/progress-bar/progress_bar.vue";
import ModalPage from "../component/uikits/modal/modal_Uikit.vue";
import PopoverPage from "../component/uikits/popover/PopoverPage.vue";
import TooltipPage from "../component/uikits/tooltip/TooltipPage.vue";
import SpinnersPage from "../component/uikits/Spinners/spinners_Uikit.vue";
import DropdownPage from "../component/uikits/dropdown/dropdown_Uikit.vue";
import AccordionPage from "../component/uikits/accordion/accordion_Uikit.vue";
import BoxshadowPage from "../component/uikits/box-shadow/BoxshadowPage.vue";
import ListsPage from "../component/uikits/lists/ListsPage.vue";
import AlertPage from "../component/uikits/alert/alert_Uikit.vue";
import bootstraptabPage from "../component/uikits/tabs/bootstraptab/bootstraptabPage.vue";
import linetabPage from "../component/uikits/tabs/linetab/linetabPage.vue";
import taskPage from '../component/task/indexPage.vue'
import socialApp from '../component/socialApp/socialApp.vue'

import Scrollable from "../component/advance/scollable/scrollable_advance.vue";
import Sweetalert from "../component/advance/sweetalert/sweetAert.vue";
import Tree from "../component/advance/tree/treeView.vue";
import Rating from "../component/advance/rating/ratingView.vue";
import Pagination from "../component/advance/pagination/pagination_advance.vue";
import Ribbons from "../component/advance/ribbons/ribbons_advance.vue";
import Tour from "../component/advance/tour/tourView.vue";

import Breadcrumb from "../component/advance/breadcrumbs/breadCrumb.vue";

import Sticky from "../component/advance/sticky/stickyView.vue";

import ImageCropper from "../component/advance/image_cropper/cropper_advance.vue";
import Notify from '../component/advance/notify/toaster_advance.vue'
import dropzone from '../component/advance/dropzone/dropzoneView.vue';
import animatedModal from '../component/advance/animatedModal/animatedModal.vue'
import owlCarousel from '../component/advance/owlCarousel/owlCarousel.vue' 
import Rangeslider from '../component/advance/range/rangeView.vue'
import BasicCard from '../component/advance/basicCard/basicCard.vue'
import CreativeCard from '../component/advance/creativeCard/creative_card.vue'
import DraggableCard from '../component/advance/draggableCard/draggableCard.vue'
import TabbedCard from '../component/advance/tabbedCard/tabbed_card.vue'
import timeLine from '../component/advance/timeLine/timeLine.vue'
import timeLine2 from '../component/advance/timeLine/timeLine2.vue'

import flagIcon from '../component/icon/flag_Icon.vue'
import fontAwesome from '../component/icon/fontAwesome/font_Awesome.vue'
import icoIcon from '../component/icon/icon_Icon.vue'
import themifyIcon from '../component/icon/themify_icon.vue'
import featherIcon from '../component/icon/feather_icon.vue'
import whetherIcon from '../component/icon/weather_icon.vue'

import animate from '../component/animation/animate/animatePage.vue'
import aos from '../component/animation/aos/aosPage.vue'
import scroll from '../component/animation/scroll/scrollPage.vue'

import wow from '../component/animation/wow/wowPage.vue'

import default_button from "../component/button/Default/default_button.vue"
import flat_button from "../component/button/Flat/flat_button.vue"
import edge_button from "../component/button/Edge/edge_button.vue"
import raised_button from "../component/button/Raised/raised_button.vue"
import button_group from "../component/button/ButtonGroup/button_group.vue"

import google_chart from "../component/charts/googleChart/google_chart"
import apex_chart from "../component/charts/ApexChart/apex_chart"

 import chartist_chart from "../component/charts/chartist/chartist_chart.vue"

import sample_page from "../component/sample_page"

import grid_gallery from "../component/gallery/grid_gallery"
import grid_desc from "../component/gallery/grid_desc"
import hover_gallery from "../component/gallery/hover-gallery/hover_gallery"
import masonry_gallery from "../component/gallery/masonry-gallery/masonry_gallery"
import masonary_desc from "../component/gallery/masonary_desc.vue"

import blog_detail from "../component/blog/blog-details/blog_detail"
import blog_single from "../component/blog/blog-single/blog_single"
import blog_add from "../component/blog/blog-add/addBlog.vue"

import faqindex from "../component/faq/faqIndex.vue"

import job_list from "../component/job/job-list/job_list"
import job_details from "../component/job/job_details/job_details"
import job_apply from "../component/job/job_apply/job_apply"
import job_card from "../component/job/job_card/cardJob.vue"

import learning_list from "../component/learning/learninglist/learning_list"
import coursedetailed from "../component/learning/courseDetailed"

import google_map from "../component/maps/google_map"
import vue_leaflet from "../component/maps/vue_leaflet"

import knowledge from '../component/Knowledgebase/knowledgeBase.vue'
import category_knowledge from '../component/Knowledgebase/categoryKnowledge.vue'
import detail_knowledge from '../component/Knowledgebase/detailsKnowledge.vue' 

import support from "../component/support/supportPage.vue"

import Error400 from '../component/errors/error_400.vue';
import Error401 from '../component/errors/error_401.vue';
import Error403 from '../component/errors/error_403.vue';
import Error404 from '../component/errors/error_404.vue';
import Error405 from '../component/errors/error_405.vue';

import ComingsoonImage from '../component/comingsoon/comingsoon_image';
import ComingsoonSimple from '../component/comingsoon/comingsoon_simple';
import ComingsoonVideo from '../component/comingsoon/comingsoon_video';

import searchView from "../component/search/serchIndex"

import loginSimple from '../component/authentication/loginsimple/loginSimple.vue'
import loginAdvance from "../auth/loginPgae.vue"
import loginImage from "../component/authentication/loginImage/loginImage.vue"
import loginBig from "../component/authentication/loginBigImage/loginBig.vue"
import registerSimple from '../component/authentication/registersimple/registerSimple.vue'
import registerImage from '../component/authentication/registerImage/registerImage.vue'
import registerBig from '../component/authentication/registerBig/registerBig.vue'
import unlockuser from '../component/authentication/unlock/unlockPage.vue'
import resetPassword from '../component/authentication/reset/resetPassword.vue'
import forgetPassword from '../component/authentication/forgetPassword/forgetPassword.vue'
import validate from '../component/authentication/loginValidation/loginValidation.vue'

import payment from '../component/ecommerce/checkout/detailsOrde.vue'

import ckediter from "../component/editer/ck_editer.vue"
import simple_editer from "../component/editer/simple_editer.vue"

const routes = [
  {
    path: "",
    redirect: "/dashboard/default",
  },
  {
    path: '/',
    component: BodyView,

    children: [
      {
        path: '',
        name: 'defaultRoot',
        component: indexDefault,
        meta: {
          title: 'Koho - Premium Vue Admin Template',
        }
      },

    ]
  },
  {
    path:"/auth",
    component: auth,
    children:[
      {
        path:"login",
        name:"login",
        component:login,
        meta: {
          title: 'Koho - Premium Vue Admin Template',
        }
      }
    ]
  },

  {
    path:'/payment',
    component: payment
  },
  {
    path: '/dashboard',
    component: BodyView,

    children: [
      {
        path: 'default',
        name: 'defaultIndex',
        component: indexDefault,
        meta: {
          title: 'Dashboard Default | Koho - Premium Vue Admin Template',
        }
      },
      {
        path: 'ecommerce',
        name: 'E-Commerce',
        component: indexEcommerce,
        meta: {
          title: 'Dashboard Ecommerce | Koho - Premium Vue Admin Template',
        }
      },

    ]
  },
  {
    path: '/widgets',
    component: BodyView,
    children: [
      {
        path: 'general',
        name: 'general',
        component: indexGeneral,
        meta: {
          title: 'Widgets General | Koho - Premium Vue Admin Template',
        }
      },
      {
        path: 'chart',
        name: 'charts',
        component: indexChart,
        meta: {
          title: 'Widgets Chart | Koho - Premium Vue Admin Template',
        }
      }
    ]
  },
  {
    path: '/project',
    component: BodyView,
    children: [
      {
        path: 'projectlist',
        name: 'projectlist',
        component: indexList,
        meta: {
          title: 'Project List| Koho - Premium Vue Admin Template',
        }
      },
      {
        path: 'createproject',
        name: 'createProject',
        component: createProject,
        meta: {
          title: 'Create Project| Koho - Premium Vue Admin Template',
        }
      }
    ]
  },
  {
    path: '/app',
    component: BodyView,
    children:
      [
        {
          path: 'fileManager',
          name: 'fileManager',
          component: fileManager,
          meta: {
            title: 'File Manager| Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'kanban',
          component: kanbanView,
          name: 'kanbanView',
          meta: {
            title: 'kanban Board| Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'bookmark',
          component: bookMark,
          name: 'bookMark',
          meta: {
            title: 'Bookmark| Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'contact',
          component: contactView,
          name: 'contactView',
          meta: {
            title: 'contact| Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'task',
          component: taskPage,
          name: 'taskPage',
          meta: {
            title: 'Task| Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'calendar',
          component: calendarView,
          name: 'calendarView',
          meta: {
            title: 'Calendar| Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'social-app',
          component: socialApp,
          name: 'socialApp',
          meta: {
            title: 'Social App| Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'todo',
          component: todoView,
          name: 'todoView',
          meta: {
            title: 'To Do| Koho - Premium Vue Admin Template',
          }
        },
     
        {
        path: 'search',
        name: 'searchView',
        component: searchView,
        meta: {
          title: 'Search| Koho - Premium Vue Admin Template',
        }
        }
      ]
  },
  {
    path: "/ecommerce",
    component: BodyView,
    children: [
      {
        path: "product",
        name: "Product",
        component: indexProduct,
        meta: {
          title: "Products | koho - Premium Admin Template",
        },
      },
      {
        path: "product/page/:id",
        name: "ProductPage",
        component: productPage,
        meta: {
          title: "Products Page | koho - Premium Admin Template",
        },
      },
      {
        path: "product/list",
        name: "productList",
        component: productList,
        meta: {
          title: "Products list | koho - Premium Admin Template",
        },
      },
      {
        path: "payment/details",
        name: "paymentDetails",
        component: paymentDetails,
        meta: {
          title: "Payment Details | koho - Premium Admin Template",
        },
      },
      {
        path: "order/history",
        name: "Order History",
        component: orderHistory,
        meta: {
          title: "OrderHistory | koho - Premium Admin Template",
        },
      },
      {
        path: "invoice",
        name: "Invoice",
        component: invoiceView,
        meta: {
          title: "Invoice | koho - Premium Admin Template",
        },
      },
      {
        path: "cart",
        name: "Cart",
        component: cartView,
        meta: {
          title: "Cart | koho - Premium Admin Template", 
        },
      },
      {
        path: "wishlist",
        name: "Wishlist",
        component: wishlistView,
        meta: {
          title: "Wishlist | koho - Premium Admin Template",
        },
      },
      {
        path: "checkout",
        name: "Checkout",
        component: checkoutView,
        meta: {
          title: "Checkout | koho - Premium Admin Template",
        },
      },
      {
        path: "pricing",
        name: "pricing",
        component: pricingView,
        meta: {
          title: "pricingView | koho - Premium Admin Template",
        },
      },


    ],
  },
  {
    path: '/email',
    component: BodyView,
    children: [
      {
        path: "mailInbox",
        name: "mailInbox",
        component: mailInbox,
        meta: {
          title: 'Mail Index| Koho - Premium Vue Admin Template',
        }
      },
      {
        path: "readMail",
        name: "readMail",
        component: readMail,
        meta: {
          title: 'Read Mail| Koho - Premium Vue Admin Template',
        }
      },
      {
        path: "compose",
        name: "compose",
        component: composeView,
        meta: {
          title: 'Compose| Koho - Premium Vue Admin Template',
        }
      }
    ]
  },
  {
    path: '/chat',
    component: BodyView,
    children: [
      {
        path: "chatApp",
        name: "chatApp",
        component: chatApp,
        meta: {
          title: 'Chat App| Koho - Premium Vue Admin Template',
        }
      },
      {
        path: "videoChat",
        name: "videoChat",
        component: videoChat,
        meta: {
          title: 'Video Chat| Koho - Premium Vue Admin Template',
        }
      },

    ]
  },
  {
    path: '/users',
    component: BodyView,
    children: [
      {
        path: "profile",
        name: "profile",
        component: userProfile,
        meta: {
          title: 'User Profile| Koho - Premium Vue Admin Template',
        }
      },
      {
        path: "edit",
        name: "edit",
        component: userEdit,
        meta: {
          title: 'User Edit| Koho - Premium Vue Admin Template',
        }
      },
      {
        path: "cards",
        name: "cards",
        component: userCards,
        meta: {
          title: 'User Cards| Koho - Premium Vue Admin Template',
        }
      }
    ]
  },
  
  {
    path:"/form",
    component:BodyView,
    children:[
      {
        path:"validation",
        name:"formValidation",
        component:formValidation,
        meta: {
          title: 'Form Controls Form Validation | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"inputs",
        name:"basicInput",
        component:base_Input,
        meta: {
          title: 'Form Controls Base Input | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"checkbox-radio",
        name:"checkbox & radio",
        component:checkbox_radio,
        meta: {
          title: 'Form Controls Checkbox & Radio | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"input-groups",
        name:"input Groups",
        component:input_groups,
        meta: {
          title: 'Form Controls Input Groups | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"mega-options",
        name:"megaOptions",
        component:megaOptions,
        meta: {
          title: 'Form Controls Mega Options | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"select2",
        name:"select2",
        component:select2,
        meta: {
          title: 'Form Widgets Select | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"switch",
        name:"switch",
        component:switch_From,
        meta: {
          title: 'Form Widgets Switch| Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"touchspin",
        name:"touchspin",
        component:touchspin_Form,
        meta: {
          title: 'Form Widgets Touchspin | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"typeahead",
        name:"typeahead",
        component:typeahead_Form,
        meta: {
          title: 'Form Widgets Typeahead | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"clipboard",
        name:"clipboard",
        component:clipboard_Form,
        meta: {
          title: 'Form Widgets Clipboard | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"wizard2",
        name:"form_wizard2",
        component:form_wizard2,
        meta: {
          title: 'Form Layout Form Wizard 2| Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"wizard1",
        name:"formwizard",
        component:form_wizard1,
        meta: {
          title: 'Form Layout Form Wizard | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"wizard3",
        name:"formwizard3",
        component:form_wizard3,
        meta: {
          title: 'Form Layout Form Wizard 3| Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"defaultforms",
        name:"defaultforms",
        component:defaultforms,
        meta: {
          title: 'Default Forms| Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"datepicker",
        name:"datepicker",
        component:datepicker,
        meta: {
          title: 'Form Widgets Datepicker | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"timepicker",
        name:"timepicker",
        component:timepicker,
        meta: {
          title: 'Form Widgets Timepicker | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"datetimepicker",
        name:"datetimepicker",
        component:datetimepicker,
        meta: {
          title: 'Form Widgets Datetimepicker | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"daterangepicker",
        name:"daterangepicker",
        component:daterangepicker,
        meta: {
          title: 'Form Widgets Daterangepicker | Koho - Premium Vue Admin Template',
        }
      }
    ]
  },
  {
    path:"/table",
    component:BodyView,
    children:[
      {
        path:"basic",
        name:"basic1",
        component:BootstrapBasic,
        meta: {
          title: 'Table Bootstrap Table | Koho - Premium Vue Admin Template',
        }
      },
      
      {
        path:"tableComponents",
        name:"tableComponents",
        component:BootstrapTablelayout,
        meta: {
          title: 'Table Table Components | Koho - Premium Vue Admin Template',
        }
      },
      
      {
        path:"/datatable-basic",
        name:"datatable",
        component:DatatableBasic,
        meta: {
          title: 'Table Basic Init | Koho - Premium Vue Admin Template',
        }
      },
      
 
    ]
  },
  
  {
    path: "/uikits",
    component: BodyView,
    children: [
     
      {
        path: "helper-classes",
        name: "HelperclassesPage",
        component: HelperclassesPage,
        meta: {
          title: "Helperclasses | Koho - Premium Admin Template",
        },
      },
      {
        path: "avatars",
        name: "AvatarsPage",
        component: AvatarsPage,
        meta: {
          title: "Avatars | Koho - Premium Admin Template",
        },
      },
      {
        path: "grid",
        name: "GridPage",
        component: GridPage,
        meta: {
          title: "Grid | Koho - Premium Admin Template",
        },
      },
      {
        path: "tag-pills",
        name: "TagpillsPage",
        component: TagpillsPage,
        meta: {
          title: "Tagpills | Koho - Premium Admin Template",
        },
      },
      {
        path: "typography",
        name: "TypographyPage",
        component: TypographyPage,
        meta: {
          title: "Typography | Koho - Premium Admin Template",
        },
      },
      {
        path: "progress-bar",
        name: "ProgressbarPage",
        component: ProgressbarPage,
        meta: {
          title: "Progressbar | Koho - Premium Admin Template",
        },
      },
      {
        path: "modal",
        name: "ModalPage",
        component: ModalPage,
        meta: {
          title: "Modal | Koho - Premium Admin Template",
        },
      },
      {
        path: "alert",
        name: "AlertPage",
        component: AlertPage,
        meta: {
          title: "Alert | Koho - Premium Admin Template",
        },
      },
      {
        path: "popover",
        name: "PopoverPage",
        component: PopoverPage,
        meta: {
          title: "Popover | Koho - Premium Admin Template",
        },
      },
      {
        path: "tooltip",
        name: "TooltipPage",
        component: TooltipPage,
        meta: {
          title: "Tooltip | Koho - Premium Admin Template",
        },
      },
      {
        path: "loader",
        name: "SpinnersPage",
        component: SpinnersPage,
        meta: {
          title: "Spinners | Koho - Premium Admin Template",
        },
      },
      {
        path: "dropdown",
        name: "DropdownPage",
        component: DropdownPage,
        meta: {
          title: "Dropdown | Koho - Premium Admin Template",
        },
      },
      {
        path: "accordion",
        name: "AccordionPage",
        component: AccordionPage,
        meta: {
          title: "Accordion | Koho - Premium Admin Template",
        },
      },
      {
        path: "bootstraptab",
        name: "bootstraptabPage",
        component: bootstraptabPage,
        meta: {
          title: "tab | Koho - Premium Admin Template",
        },
      },
      {
        path: "linetab",
        name: "linetabPage",
        component: linetabPage,
        meta: {
          title: "Accordion | Koho - Premium Admin Template",
        },
      },
      {
        path: "box-shadow",
        name: "BoxshadowPage",
        component: BoxshadowPage,
        meta: {
          title: "Boxshadow | Koho - Premium Admin Template",
        },
      },
      {
        path: "lists",
        name: "ListsPage",
        component: ListsPage,
        meta: {
          title: "Lists | Koho - Premium Admin Template",
        },
      },
    ],
  },

  {
    path: "/icons",
    component: BodyView,
    children: [
        {
            path: "flag",
            name: "flagIcon",
            component: flagIcon,
            meta: {
                title: "FlagIcon | Koho - Premium Admin Template",
            },
        },
        {
          path: "fontawesome",
          name: "fontAwesome",
          component: fontAwesome,
          meta: {
              title: "Tree | Koho - Premium Admin Template",
          },
      },
      {
        path: "ico",
        name: "icoIcon",
        component: icoIcon,
        meta: {
            title: "Tree | Koho - Premium Admin Template",
        },
    },
    {
      path: "themify",
      name: "themifyIcon",
      component: themifyIcon,
      meta: {
          title: "themifyIcon | Koho - Premium Admin Template",
      },
  },
  {
    path: "feather_icon",
    name: "featherIcon",
    component: featherIcon,
    meta: {
        title: "featherIcon | Koho - Premium Admin Template",
    },
},
{
  path: "whether",
  name: "whetherIcon",
  component: whetherIcon,
  meta: {
      title: "whetherIcon | Koho - Premium Admin Template",
  },
},
    ]
  },

  {
    path: "/advance",
    component: BodyView,
    children: [
        {
            path: "scrollable",
            name: "Scrollable",
            component: Scrollable,
            meta: {
                title: "Scrollable | Koho - Premium Admin Template",
            },
        },
        {
          path: "treeView",
          name: "Tree",
          component: Tree,
          meta: {
              title: "Tree | Koho - Premium Admin Template",
          },
      },
        {
          path: "notify",
          name: "notify",
          component: Notify,
          meta: {
              title: "Scrollable | Koho - Premium Admin Template",
          },
        },
        {
          path: "rating",
          name: "Rating",
          component: Rating,
          meta: {
              title: "Rating | Koho - Premium Admin Template",
          },
      },
      {
        path: "dropzone",
        name: "dropzone",
        component: dropzone,
        meta: {
            title: "dropzone | Koho - Premium Admin Template",
        },
    },
    {
      path: "tour",
      name: "Tour",
      component: Tour,
      meta: {
          title: "Tour | Koho - Premium Admin Template",
      },
  },
        {
            path: "sweetalert",
            name: "Sweetalert",
            component: Sweetalert,
            meta: {
                title: "Sweetalert | Koho - Premium Admin Template",
            },
        },
        {
          path: "animatedModal",
          name: "animatedModal",
          component: animatedModal,
          meta: {
              title: "Sweetalert | Koho - Premium Admin Template",
          },
      },
      {
        path: "owlCarousel",
        name: "owlCarousel",
        component: owlCarousel,
        meta: {
            title: "Sweetalert | Koho - Premium Admin Template",
        },
    },
       
        {
            path: "ribbons",
            name: "Ribbons",
            component: Ribbons,
            meta: {
                title: "Ribbons | Koho - Premium Admin Template",
            },
        },
        {
          path: "pagination",
          name: "Pagination",
          component: Pagination,
          meta: {
              title: "Pagination | Koho - Premium Admin Template",
          },
      },
      {
        path: "breadcrumb",
        name: "Breadcrumb",
        component: Breadcrumb,
        meta: {
            title: "Breadcrumb | Koho - Premium Admin Template",
        },
    },
        {
            path: "range-slider",
            name: "Rangeslider",
            component: Rangeslider,
            meta: {
                title: "Rangeslider | Koho - Premium Admin Template",
            },
        },
        {
          path: "image-cropper",
          name: "ImageCropper",
          component: ImageCropper,
          meta: {
              title: "ImageCropper | Koho - Premium Admin Template",
          },
      },
        
        {
            path: "sticky",
            name: "Sticky",
            component: Sticky,
            meta: {
                title: "Sticky | Koho - Premium Admin Template",
            },
        },
        {
          path: "basicCard",
          name: "basicCard",
          component: BasicCard,
          meta: {
              title: "Sticky | Koho - Premium Admin Template",
          },
      },
      {
        path: "creativeCard",
        name: "creativeCard",
        component: CreativeCard,
        meta: {
            title: "Sticky | Koho - Premium Admin Template",
        },
    },
    {
      path: "TabbedCard",
      name: "TabbedCard",
      component: TabbedCard,
      meta: {
          title: "Sticky | Koho - Premium Admin Template",
      },
  },
  {
    path: "DraggableCard",
    name: "DraggableCard",
    component: DraggableCard,
    meta: {
        title: "Sticky | Koho - Premium Admin Template",
    },
},
        {
            path: "timeline1",
            name: "timeline",
            component: timeLine,
            meta: {
                title: "Toastr | Koho - Premium Admin Template",
            },
        },
        {
          path: "timeline2",
          name: "timeline2",
          component: timeLine2,
          meta: {
              title: "Toastr | Koho - Premium Admin Template",
          },
      },
        
    ],
},
{
  path:"/editor",
  component:BodyView,
  children:[
    {
      path:"ck-editor",
      name:"ckediter",
      component:ckediter,
      meta: {
        title: 'Ck Editor | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"simple-editor",
      name:"simple-editer",
      component:simple_editer,
      meta: {
        title: 'Simple Editor | Koho - Premium Vue Admin Template',
      }
    }
  ]
},

{
  path: "/animation",
  component: BodyView,
  children: [
      {
          path: "animate",
          name: "animate",
          component: animate,
          meta: {
              title: "animate | Koho - Premium Admin Template",
          },
      },
      {
        path: "scroll",
        name: "scroll",
        component: scroll,
        meta: {
            title: "scroll | Koho - Premium Admin Template",
        },
    },
      {
        path: "AOS",
        name: "aos",
        component: aos,
        meta: {
            title: "aos | Koho - Premium Admin Template",
        },
      },
  
    {
      path: "wow",
      name: "wow",
      component: wow,
      meta: {
          title: "wow | Koho - Premium Admin Template",
      },
  },
    ],
},
{
  path:"/buttons",
  component:BodyView,
  children:[
    {
      path:"default",
      name:"default",
      component:default_button,
      meta: {
        title: 'Button Default | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"flat",
      name:"flat",
      component:flat_button,
      meta: {
        title: 'Flat Button | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"edge",
      name:"edge",
      component:edge_button,
      meta: {
        title: 'Edge Button | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"raised",
      name:"raised",
      component:raised_button,
      meta: {
        title: 'raised Button | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"group",
      name:"button_group",
      component:button_group,
      meta: {
        title: 'Group Button | Koho - Premium Vue Admin Template',
      }
    }
  ]
},
{
  path:"/chart",
  component:BodyView,
  children:[
    {
      path:"google",
      name:"googlechart",
      component:google_chart,
      meta: {
        title: 'Chart Google Chart | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"apexChart",
      name:"apexchart",
      component:apex_chart,
      meta: {
        title: 'Chart Apex Chart | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"chartist",
      name:"chartist",
      component:chartist_chart,
      meta: {
        title: 'Chart Chartist Chart | Koho - Premium Vue Admin Template',
      }
    },
   
  ]
},
{
  path:"/pages",
  component:BodyView,
  children:[
  
    {
      path:"sample-page",
      name:"samplepage",
      component:sample_page,
      meta: {
        title: 'Simple Page| Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"faq",
      name:"faqindex",
      component:faqindex,
      meta: {
        title: 'Faq| Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"support",
      name:"support",
      component:support,
      meta: {
        title: 'Support | Koho - Premium Vue Admin Template',
      }
    },
 
   
  ]
},
{
  path:"/gallery",
  component:BodyView,
  children:[
    {
      path:"grid-gallery",
      name:"gridgallery",
      component:grid_gallery,
      meta: {
        title: 'Grid Gallery | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"gallery-desc",
      name:"griddesc",
      component:grid_desc,
      meta: {
        title: 'Grid Gallery With Desc | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"hover-effect",
      name:"hovergallery",
      component:hover_gallery,
      meta: {
        title: 'Hover Gallery | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"gallery-masonary",
      name:"masonry-gallery",
      component:masonry_gallery,
      meta: {
        title: 'Masonry | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"gallery-masonary-desc",
      name:"masonary-desc",
      component:masonary_desc,
      meta: {
        title: 'Masonry Desc | Koho - Premium Vue Admin Template',
      }
    }

  ]
},
{
  path:"/blog",
  component:BodyView,
  children:[
    {
      path:"details",
      name:"blog-detail",
      component:blog_detail,
      meta: {
        title: 'Blog Details | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"single",
      name:"blog_single",
      component:blog_single,
      meta: {
        title: 'Blog Single | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"add",
      name:"blog_add",
      component:blog_add,
      meta: {
        title: 'Add Post | Koho - Premium Vue Admin Template',
      }
    }
    
  ]
},
{
  path:"/job",
  component:BodyView,
  children:[
    {
      path:"card",
      name:"cardview",
      component:job_card,
      meta: {
        title: 'Job Card | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"list",
      name:"listview",
      component:job_list,
      meta: {
        title: 'Job List | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"/job/details/:id",
      name:"jobdetails",
      component:job_details,
      props:true,
      meta: {
        title: 'Job Details | Koho - Premium Vue Admin Template',
      }
    },
    {
      path:"apply/:id",
      name:"jobapply",
      component:job_apply,
      meta: {
        title: 'Job Apply | Koho - Premium Vue Admin Template',
      }
    }
  ]},
  {
    path:"/learning",
    component:BodyView,
    children:[
      {
        path:"list",
        name:"learninglist",
        component:learning_list,
        meta: {
          title: 'Learning List | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"details/:id",
        name:"coursedetailed",
        component:coursedetailed,
        meta: {
          title: 'course Detailed | Koho - Premium Vue Admin Template',
        }
      }
    ]
  },
  {
    path:"/maps",
    component:BodyView,
    children:[
      {
        path:"vue-google-maps",
        name:"google-map",
        component:google_map,
        meta: {
          title: 'Google Map | Koho - Premium Vue Admin Template',
        }
      },
      {
        path:"vue-leaflet-maps",
        name:"vueleaflet",
        component:vue_leaflet,
        meta: {
          title: 'Leaflet Map | Koho - Premium Vue Admin Template',
        }
      }
    ]},
    {
      path: '/knowledgebase',
      component: BodyView,
      children: [
        {
          path: "knowledgebase",
          name: 'knowledge',
          component: knowledge,
          meta: {
            title: 'Knowledgebase | Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'category',
          name: 'category_knowledge',
          component: category_knowledge,
          meta: {
            title: 'Knowledgebase Category | Koho - Premium Vue Admin Template',
          }
        },
        {
          path: 'detail',
          name: 'detail_knowledge',
          component: detail_knowledge,
          meta: {
            title: 'Knowledgebase  Details| Koho - Premium Vue Admin Template',
          }
        }
      ]
    },
    {
      path: '/error-400',
      name: 'Error400',
      component: Error400,
      meta: {
        title: 'Error400 | Koho - Premium Admin Template',
      }
    },
    {
      path: '/error-401',
      name: 'Error401',
      component: Error401,
      meta: {
        title: 'Error401 | Koho - Premium Admin Template',
      }
    },
    {
      path: '/error-403',
      name: 'Error403',
      component: Error403,
      meta: {
        title: 'Error403 | Koho - Premium Admin Template',
      }
    },
    {
      path: '/error-404',
      name: 'Error404',
      component: Error404,
      meta: {
        title: 'Error404 | Koho - Premium Admin Template',
      }
    },
    {
      path: '/error-405',
      name: 'Error405',
      component: Error405,
      meta: {
        title: 'Error405 | Koho - Premium Admin Template',
      }
    },
    {
      path:'/comingsoon/comingsoon-image',
      name:'ComingsoonImage',
      component:ComingsoonImage,
      meta: {
          title: 'ComingsoonImage | Koho - Premium Admin Template',
        }
    },
    {
      path:'/comingsoon/comingsoon-simple',
      name:'ComingsoonSimple',
      component:ComingsoonSimple,
      meta: {
          title: 'ComingsoonSimple | Koho - Premium Admin Template',
        }
    },
    {
      path:'/comingsoon/comingsoon-video',
      name:'ComingsoonVideo',
      component:ComingsoonVideo,
      meta: {
          title: 'ComingsoonVideo | Koho - Premium Admin Template',
        }
    },
    {
      path: '/authentication/login',
      name:'loginSimple',
      component: loginSimple,
      meta:{
        title: 'loginSimple | Koho -Premium Admin Template'
      }
    },
    {
      path: '/auth/login',
      name:'loginAdvance',
      component: loginAdvance,
      meta:{
        title: 'loginSimple | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/validate',
      name:'validate',
      component: validate,
      meta:{
        title: 'validate | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/one',
      name:'loginImage',
      component: loginImage,
      meta:{
        title: 'loginImage | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/two',
      name:'loginBig',
      component: loginBig,
      meta:{
        title: 'loginBig | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/register',
      name:'registerSimple',
      component: registerSimple,
      meta:{
        title: 'registerSimple | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/image',
      name:'registerImage',
      component: registerImage,
      meta:{
        title: 'registerImage | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/image2',
      name:'registerBig',
      component: registerBig,
      meta:{
        title: 'registerBig | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/unlockuser',
      name:'unlockuser',
      component: unlockuser,
      meta:{
        title: 'unlockuser | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/forgetpassword',
      name:'forgetpassword',
      component: forgetPassword,
      meta:{
        title: 'forgetpassword | Koho -Premium Admin Template'
      }
    },
    {
      path: '/authentication/resetpassword',
      name:'resetpassword',
      component: resetPassword,
      meta:{
        title: 'resetpassword | Koho -Premium Admin Template'
      }
    }
]

const router = createRouter({
  history: createWebHistory('/koho/'),
  routes,
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
})


router.beforeEach((to, from, next) => {
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  }
  const  path = ['/auth/login','/auth/register'];
  if (path.includes(to.path) || localStorage.getItem('user')  ){
    return next();
  }
  next('/auth/login');
});

  

export default router